export const firebaseConfig = {
    apiKey: "AIzaSyD_bOw8sRO6LD-voTYPn2BFrjch4pYdYcA",
    authDomain: "nsp-wallet.firebaseapp.com",
    projectId: "nsp-wallet",
    storageBucket: "nsp-wallet.appspot.com",
    messagingSenderId: "660540445156",
    appId: "1:660540445156:web:f0e5bec251f0407584b7f1",
    measurementId: "G-HDMKE3QPT1"
};